import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% Rabatt ab {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Sparen Sie {{percentageAmount}}% auf ausgewählte Artikel',
  [OfferKindEnum.AmountOffByProducts]: 'Sparen Sie {{amount}} auf ausgewählte Artikel',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Sparen Sie {{amount}} ab {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 zum Preis von 1 – Nur heute',
  [OfferKindEnum.BogoHalfPrice]: '1 kaufen, das zweite zum halben Preis',
  [OfferKindEnum.FreeItemByProducts]: 'Heute: Sichern Sie sich Ihren Gratisartikel!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Heute: Sichern Sie sich Ihren kostenlosen Artikel bei einem Bestellwert!',
};

export default OfferLabel;
